import React from 'react';
import groupBy from 'lodash/groupBy';
import orderBy from 'lodash/orderBy';
import FeatureBlock from '../FeatureBlock/FeatureBlock';
import {
  CustomAccordion,
  CustomAccordionItem,
  CustomAccordionItemHeading,
  CustomAccordionItemButton,
  CustomAccordionItemPanel,
} from '../../components/UI/CustomAccordion/CustomAccordion';
import { GridReveal, GridItem } from '../UI/Grid/Grid';
import useResponsive from '../../hooks/useResponsive';
import Section from '../UI/Section/Section';
import Columns from '../UI/Columns/Columns';
import NavList from '../UI/NavList/NavList';
import Type from '../UI/Type/Type';

const ServicesGrouped = ({ nodes }) => {
  const { isLarge } = useResponsive();  
  const servicesGrouped = groupBy(nodes, node => {
    return node.servicesCategory.nodes[ 0 ]?.name;
  });

  return isLarge ? (
    <Columns count={4} showBorders={false}>
      {Object.keys(servicesGrouped).sort().map(key => (
        <React.Fragment key={key}>
          <Type.H3>{key}</Type.H3>
          <NavList nodes={servicesGrouped[ key ].map(({ id, title, uri }) => ({
            label: title,
            path: uri,
            id,
          }))} />
        </React.Fragment>
      ))}
    </Columns>
  ) : (
    <CustomAccordion isBordered collapsible>
      {Object.keys(servicesGrouped).sort().map(key => (
        <CustomAccordionItem uuid={key} key={key}>
          <CustomAccordionItemHeading>
            <CustomAccordionItemButton>
              {key}
            </CustomAccordionItemButton>
          </CustomAccordionItemHeading>
          <CustomAccordionItemPanel>
            <NavList nodes={servicesGrouped[ key ].map(({ id, title, uri }) => ({
              label: title,
              path: uri,
              id,
            }))} />
          </CustomAccordionItemPanel>
        </CustomAccordionItem>
      ))}
    </CustomAccordion>
  )
}

const Services = ({ nodes, ...other }) => {
  const nodesSorted = nodes?.length ? orderBy(nodes, 'title', 'asc') : null;

  return !nodesSorted?.length ? null : (
    <Section
      isInnerOffsetY
      id="services"
      {...other}
    >
      {nodesSorted.length > 6 && nodesSorted[ 0 ].servicesCategory ? (
        <ServicesGrouped nodes={nodesSorted}/>
      ) : (
        <GridReveal>
          {nodesSorted.map(({ id, title, uri, cover: { lead, image } }) => {
            return (
              <GridItem key={id} lg={6}>
                <FeatureBlock
                  title={title}
                  description={lead}
                  image={image}
                  path={uri}
                />
              </GridItem>
            );
          })}
        </GridReveal>
      )}
    </Section>
  );
};

export default Services;
